import moment from "moment";
import { FunctionComponent, useMemo } from "react";
import { Table } from "../../../../components/table";
import { UsersDTO } from "../../../../store/users/models/dto";
import { ResetTFA, StyledWidget, Update2FA } from "../common/components";

export const TwoFactorDetails: FunctionComponent<{
  item: UsersDTO.Responses.GetSingle.T;
}> = ({ item }) => {
  const { userReferenceId, currentProvider, registeredProviders } = item;

  const totps = useMemo(
    () =>
      registeredProviders.map((x) => ({
        ...x,
        reset: x.provider,
        current: x.provider,
      })),
    [registeredProviders]
  );

  return (
    <StyledWidget
      title="Two Factor Auth Methods"
      adornment={
        currentProvider !== "NONE" ? (
          <Update2FA userId={userReferenceId} />
        ) : null
      }
    >
      <Table
        data={totps}
        head={[
          { name: "provider", title: "Provider" },
          { name: "registeredAt", title: "Registered At" },
          { name: "state", title: "State" },
          { name: "reset", title: "Reset Method", centered: true },
          { name: "current", title: "Set Default Provider", centered: true },
        ]}
        unsortable={["reset", "state", "registeredAt", "provider", "current"]}
        renderFields={{
          provider: ({ provider }) => (
            <>
              {provider}{" "}
              {provider === currentProvider ? <strong>(current)</strong> : ""}
            </>
          ),
          registeredAt: ({ registeredAt }) => (
            <>{moment.utc(registeredAt).local().format("DD-MM-yyyy HH:mm")}</>
          ),
          reset: ({ provider }) => (
            <ResetTFA provider={provider} userId={userReferenceId} />
          ),
          current: ({ provider }) => (
            <Update2FA provider={provider} userId={userReferenceId} />
          ),
        }}
        hide={currentProvider === "NONE" ? [] : ["current"]}
      ></Table>
    </StyledWidget>
  );
};
